// @flow
import React from 'react';
import { escapeForUrl } from 'lib/common';
import { Link } from 'react-router-dom';
import './PartnerTags.scss';

type Props = {
  tags: string[],
};

const PartnerTags = ({ tags }: Props) => (
  <div className="PartnerTags">
    {tags.map(t => (
      <Link to={`/tags/${escapeForUrl(t)}`} key={t}>
        {t}
      </Link>
    ))}
  </div>
);

export default PartnerTags;



// WEBPACK FOOTER //
// ./src/components/partner/PartnerTags/PartnerTags.js